module.exports = __webpack_public_path__ + "static/media/22ESCWA11.91fe033e.jpg";